// /* --- local dev --- 
export var apiUrl = process.env.REACT_APP_API_URL;
// */ 
